import { Routing } from '@/constants';
import { getModelManagerPathMatcher } from './get-model-manager-path-matcher';
/**
 * Extract and validate collection name from URL path
 * @param pathname - Current URL pathname (e.g., '/merchandising/rules/apparel/us')
 * @param validCollections - Array of valid collection names for validation
 * @returns Collection name if valid, undefined otherwise
 */
export const getCollectionNameFromPath = (pathname, validCollections) => {
    // Strip query params if present (defensive - React Router already does this for location.pathname)
    const cleanPathname = pathname.split('?')[0];
    const match = getModelManagerPathMatcher()(cleanPathname);
    if (!match) {
        return undefined;
    }
    const { collection } = match;
    if (!collection || collection === Routing.CREATE_MODEL_SEGMENT) {
        return undefined;
    }
    // Validate collection against provided list
    const isValid = validCollections.includes(collection);
    if (!isValid) {
        console.warn(`[getCollectionNameFromPath] Invalid collection in URL: "${collection}"`, {
            pathname,
            availableCollections: validCollections,
            hint: 'User may have typo in URL or copied URL from different tenant',
        });
        return undefined;
    }
    return collection;
};
